import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { useMediaUrl } from "@/lib/storageUrl";
import { cn } from "@/lib/utils";

/**
 * Drop-in <img> replacement for stored media. Accepts a permanent storage
 * reference (storage://bucket/path), an old expired signed URL, or a plain
 * public URL, and always renders with a fresh viewable link. Missing files
 * render a quiet placeholder instead of a broken-image icon.
 */
const MediaImage = ({
  src,
  alt = "",
  className,
  onError,
  ...rest
}: React.ImgHTMLAttributes<HTMLImageElement> & { src: string | null | undefined }) => {
  const url = useMediaUrl(src);
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [url]);
  if (!url || failed) {
    return (
      <div className={cn("flex items-center justify-center bg-muted text-muted-foreground", className)} aria-label={alt}>
        {failed && <ImageOff className="h-5 w-5 opacity-50" />}
      </div>
    );
  }
  return <img src={url} alt={alt} className={className} onError={(e) => { setFailed(true); onError?.(e); }} {...rest} />;
};

export default MediaImage;
